jQuery(document).ready(function () {
    "use strict";
    ldEqualHeightSlides();
});

jQuery(window).resize(function(){
    "use strict";
    ldEqualHeightSlides();
});

function ldEqualHeightSlides() {

    jQuery('.product-slider').each(function(){
        var highestBox = 0;

        jQuery(this).find('.loop-product').each(function(){
            jQuery(this).height('auto');

            if(jQuery(this).height() > highestBox){
               highestBox = jQuery(this).height();
            }
        })

        jQuery(this).find('.loop-product').height(highestBox);
    });
}
